import { z } from "zod";

export const Subsystem = z.object({
  healthy: z.boolean(),
  tookMs: z.number(),
  checkedAt: z.string(),
  details: z.object({
    version: z.string().optional(),
    note: z.string().optional()
  }).optional()
});

export const ServicesStatus = z.object({
  kong: Subsystem, 
  pulsar: Subsystem, 
  mosquitto: Subsystem,
  mongo: Subsystem, 
  nginx: Subsystem, 
  a4: Subsystem, 
  a7: Subsystem, 
  a12: Subsystem
});

export type ServicesStatus = z.infer<typeof ServicesStatus>;
export type Subsystem = z.infer<typeof Subsystem>;

// Auth schemas
export const JWTPayload = z.object({
  iss: z.string().optional(),
  sub: z.string().optional(),
  exp: z.number(),
  iat: z.number().optional(),
  tenantId: z.string().optional(),
  tenant: z.string().optional(),
  tid: z.string().optional(),
  userId: z.string().optional(),
  role: z.string().optional(),
  roles: z.array(z.string()).optional(),
});

export type JWTPayload = z.infer<typeof JWTPayload>;
